import { render } from "./skeleton.vue?vue&type=template&id=aa1881a8&scoped=true&name=skeleton"
const script = {}

import "./skeleton.vue?vue&type=style&index=0&id=aa1881a8&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa1881a8"]])

export default __exports__